// ./src/hooks/useStickyBottomOffset.ts
//
// Returns the correct `bottom` pixel value for a position:sticky element
// that must sit above the mobile bottom tab bar.
//
// Usage:
//   const bottom = useStickyBottomOffset();
//   <Paper style={{ position: "sticky", bottom, zIndex: 100 }}>
//
// On mobile  → BOTTOM_TAB_BAR_HEIGHT + STICKY_BOTTOM_GAP (e.g. 102px)
// On desktop → STICKY_BOTTOM_GAP                          (e.g. 12px)

import { useAppEnvironment } from "@/contexts/AppEnvironmentContext";
import {
  STICKY_BOTTOM_MOBILE,
  STICKY_BOTTOM_DESKTOP,
} from "@/components/layouts/DashboardLayout/constants";

/**
 * Returns the `bottom` offset (in px) for a `position: sticky` element
 * that must float above the bottom tab bar on mobile and near the viewport
 * bottom on desktop.
 */
export const useStickyBottomOffset = (): number => {
  const { isMobile } = useAppEnvironment();
  return isMobile ? STICKY_BOTTOM_MOBILE : STICKY_BOTTOM_DESKTOP;
};